import(/* webpackMode: "eager" */ "/kingsyard-ssr/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/kingsyard-ssr/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/assets/images/warranty/banner.png");
;
import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/assets/images/warranty/mobile-banner.png");
;
import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/assets/images/warranty/section.png");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/kingsyard-ssr/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/WarrantyPage/warranty-form.jsx");
